import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import moment from 'moment';
import { CancelToken } from 'axios';
import InformativeCard from '../InformativeCard';
import cautionEnter from '../../../../assets/images/caution-enter.png';
import CustomDialog from '../../../../components/CustomDialog';
import { FUNCIONARIOS } from '../../../../models/enum/AppUsageEvolutionEnum';
import { BranchDTO } from '../../../../models/dto/BranchDTO';
import FileDownloader from '../../../../components/FileDownloader';
import {
  downloadAppUsageEvolution,
  findAllBranches,
} from '../../../../services/personnelDepartment.service';
import { getCancelTokenSource, isCancel } from '../../../../services/api';

const InactiveEmployeesCard: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [openDetailDialog, setOpenDetailDialog] = useState(false);
  const [branches, setBraches] = useState<BranchDTO[]>([]);
  const [branchIdSelected, setBranchIdSelected] = useState('');

  const twelveMonthsPeriod: { start: string; end: string } = useMemo(() => {
    return {
      start: moment().startOf('year').format('YYYY-MM-DD'),
      end: moment().endOf('year').format('YYYY-MM-DD'),
    };
  }, []);

  const findBranches = useCallback(
    async (cancelToken?: CancelToken) => {
      try {
        setLoadingBranches(loadingBranches);
        const { data } = await findAllBranches(cancelToken);
        setBraches(data);
      } catch (error) {
        if (!isCancel(error)) {
          console.log(error);
        }
      } finally {
        setLoading(loadingBranches);
      }
    },
    [loadingBranches],
  );

  useEffect(() => {
    const cancelTokenSource = getCancelTokenSource();
    findBranches(cancelTokenSource.token);
  }, [findBranches]);

  return (
    <>
      <InformativeCard
        imgAltText="Funcionários - login"
        imgSrc={cautionEnter}
        cardTitle="Logins dos Funciários"
        cardText="Veja os logins que os funcionários realizaram nos ultimos 12 meses."
        handleCardClick={() => setOpenDetailDialog(true)}
      />
      {openDetailDialog ? (
        <CustomDialog
          open={openDetailDialog}
          handleClose={() => setOpenDetailDialog(false)}
          hideDefaultButtons
          showCloseButton
          title={`Gerar CSV com dados sobre a utilização do APP pelos ${FUNCIONARIOS.label}`}
          maxWidth="md"
        >
          <Grid container justify="center" style={{ paddingBottom: '32px' }}>
            <FormControl variant="outlined">
              <InputLabel htmlFor="select-type-label">
                Selecione a Regional
              </InputLabel>
              <Select
                disabled={loading}
                disableUnderline
                value={branchIdSelected}
                variant="outlined"
                style={{ minWidth: '315px' }}
                label="Selecione a Regional"
                onChange={event =>
                  setBranchIdSelected(event.target.value as any)
                }
              >
                <MenuItem value="">Selecione uma Regional</MenuItem>
                {branches.map((item: BranchDTO) => (
                  <MenuItem key={item.idRegional} value={item.idRegional}>
                    {item.nomeRegional}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FileDownloader
              disabled={!branchIdSelected || loadingBranches}
              onSelect={downloadAppUsageEvolution}
              onSelectParams={{
                type: FUNCIONARIOS.value.toLowerCase(),
                branchId: branchIdSelected,
                startDate: twelveMonthsPeriod.start,
                endDate: twelveMonthsPeriod.end,
              }}
              icon="download"
              typeExpected="csv"
              color="primary"
            />
          </Grid>
        </CustomDialog>
      ) : null}
    </>
  );
};

export default InactiveEmployeesCard;
